module.exports = __webpack_public_path__ + "img/calendar-22.204f0f2b.svg";